/**
* 基础菜单 商品管理
*/
<template>
  <div class="contianer">
    <!-- 面包屑导航 -->
    <!-- <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>售后管理</el-breadcrumb-item>
        <el-breadcrumb-item>售后服务管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <div class="adjuster">
      <div class="flex_box mb20">
        <p class="fw600 f20 color409EFF mr50">售后服务管理</p>
        <el-row>
          <el-button type="primary" size="mini" @click="add()">新增</el-button>
        </el-row>
      </div>

      <div class="content">
        <div class="flex_box flex_wrap">
          <div class="item mr80" v-for="(item,index) in tableDataList" :key="index">
            <div class="ahead flex_box">
              <p class="fw500 f16">· {{item.title}} ·</p>
              <el-row>
                <el-button type="primary" size="mini" plain @click="edit(item.id,item.title,item.content)">编辑</el-button>
                <el-button type="danger" size="mini" plain @click="del(item.id)" v-if="index!='0'">删除</el-button>
              </el-row>
            </div>
            <div class="ordinance" v-html="formattedContent(item.content)" >
            </div>
          </div>
        </div>
      </div>
      <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
                 :title="dialogTitle"
                 :visible.sync="editDialogVisible"
                 width="40%"
                 center>
        <el-form label-width="120px" :model="serviceForm" :rules="rules" ref="serviceForm" class="serviceForm">
          <el-form-item label="售后服务标题" prop="title">
            <el-input size="small" v-model="serviceForm.title" placeholder="请输入售后服务标题" maxlength="20" clearable></el-input>
          </el-form-item>
          <el-form-item label="内容" prop="content">
            <el-input type="textarea" v-model="serviceForm.content" class="textarea" placeholder="请输入内容"
                      clearable
                      :rows="6"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="editDialogVisible = false">关 闭</el-button>
            <el-button type="primary" @click="sure('serviceForm')">确 定</el-button>
      </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import {
    sellerProductCsList, sellerProductCsAdd,
    deleteSellerProductCs, updateSellerProductCs
  } from '../../api/basisMG'

  export default {
    data: () => {
      return {
        loading: false, //是显示加载
        editDialogVisible: false, //控制页面显示与隐藏
        dialogTitle: '',
        tableDataList: [],
        serviceForm: {
          id: '',
          title: '',
          content: ''
        },
        // rules表单验证
        rules: {
          title: [
            {required: true, message: '请输入售后服务标题', trigger: 'blur'}
          ],
          content: [{required: true, message: '请输入内容', trigger: 'blur'}],
        },
      }
    },
    // 注册组件
    components: {},
    computed: {

    },

    /**
     * 创建完毕
     */
    created() {
      this.getdata()
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      formattedContent(i) {
        return i ? i.replace(/\n/g, '<br/>') : '';
      },
      // 获取公司列表
      getdata() {
        this.loading = true
        sellerProductCsList()
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.tableDataList = res.content;
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      add() {
        this.editDialogVisible = true;
        this.dialogTitle = '新增售后服务信息'
        this.serviceForm = {}
      },
      edit(id,title,content) {
        this.editDialogVisible = true;
        this.dialogTitle = '修改售后服务信息';
        this.serviceForm = {
          id: id,
          title: title,
          content: content.toString().replace(/\<br\/\>/g,"\n")
        }
      },
      del(id) {
        const title = '您是否要将该售后服务信息删除？';
        this.$confirm(title, '删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          deleteSellerProductCs(id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.getdata()
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      sure(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
           let content =  this.serviceForm.content;
          // .toString().replace(/\n/g,"<br/>")
            this.serviceForm.content = content
            if (this.dialogTitle == '新增售后服务信息') {
              sellerProductCsAdd(this.serviceForm)
                .then(res => {
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '保存成功!'
                    });
                    this.editDialogVisible = false;
                    this.getdata()
                  }
                })
                .catch(err => {
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            } else {
              updateSellerProductCs(this.serviceForm)
                .then(res => {
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '修改成功!'
                    });
                    this.editDialogVisible = false;
                    this.getdata()
                  }
                })
                .catch(err => {
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.order_code == cell.innerText || row.mobile == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      },
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
    height: calc(100% - 60px);
    border-radius: 8px;
    overflow: auto;
  }

  /deep/ .textarea .el-textarea__inner {
    height: 150px;
    width: 500px;
    resize: none;
  }

  /deep/ .serviceForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 500px;
  }

  /deep/ .serviceForm .el-input--small {
    width: 500px;
  }

  .mb20 {
    margin-bottom: 20px;
  }

  .mr50 {
    margin-right: 50px;
  }

  .mr80 {
    margin-right: 80px;
  }

  .f16 {
    font-size: 16px;
  }

  .f20 {
    font-size: 20px;
  }

  .fw500 {
    font-weight: 500;
  }

  .color409EFF {
    color: #409EFF;
  }

  .label {
    width: 120px;
    height: 40px;
    line-height: 40px;
    background: #F5F7FA;
    padding-left: 12px;
  }


  /deep/ .textarea textarea {
    resize: none;
    width: 300px;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  .adjuster {
    margin: 30px 0 0 36px;
  }

  .item {
    width: 600px;
    height: 250px;
    border: 1px solid #EBEEF5;
    border-radius: 8px;
    margin-bottom: 70px;
  }

  .ahead {
    width: 576px;
    height: 41px;
    background: #F5F7FA;
    padding: 0 12px;
    justify-content: space-between;
    align-items: center;
    box-shadow: inset 0px -1px 0px #EBEEF5;
    border-radius: 8px 8px 0px 0px;
  }

  .ordinance {
    padding: 6px 12px 7px;
    height: 195px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .text {
    text-align: justify;
    text-indent: 28px;
  }

</style>





// WEBPACK FOOTER //
// src/views/aftersale/AftersaleService.vue